<template>
  <div class="error-page">
    <md-card class="error-message">
      <md-icon class="md-size-4x">warning</md-icon>
      <template>
        <md-card-content>
          <h3 class="md-subheading">{{ getErrorMessage(key) }}</h3>
        </md-card-content>
      </template>
      <md-card-actions class="redirect-button">
        <md-button @click="goToRoot" class="md-raised md-primary">{{
          this.$t('error.redirectButton')
        }}</md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      key: this.$route.params.error,
    }
  },

  methods: {
    goToRoot() {
      this.$router.push('/')
    },

    getErrorMessage(key) {
      return this.$te(`error.message.${key}`)
        ? this.$t(`error.message.${key}`)
        : this.$t('error.message.404')
    },
  },
}
</script>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
.error-message {
  text-align: center;
  padding: 20px;
  width: 400px;
}
.redirect-button {
  display: block;
}
</style>
